module.exports = {
	DATA_HUT: [
		
	]
}



//////////////////
// WEBPACK FOOTER
// ./config/huts.js
// module id = FTsS
// module chunks = 55